import React from 'react'
import { useSelector } from 'react-redux'
import { MovableModalContainer } from 'components/MovableModal'
import { selectShowCustomizeView } from 'selectors/mainView'
import { useAction } from 'hooks'
import { showCustomizeView } from 'actions/mainView'
import { CustomizationHotkeys } from './CustomizationHotkeys'

export const CustomizationHotkeysContainer = () => {
  const customizationView = useSelector(selectShowCustomizeView)
  const onClose = useAction(showCustomizeView, false) as () => void
  return (
    <MovableModalContainer
      visible={customizationView === 'hotkeys'}
      windowId="CustomizationHotkeysContainer"
      onCloseWindow={onClose}
    >
      <CustomizationHotkeys onClose={onClose} />
    </MovableModalContainer>
  )
}
